module.exports = __webpack_public_path__ + "static/media/subGoogle4.a580b5e6.png";